import React, { useState } from "react";
import PreLoaderWidget from '../../../components/Loader';
import Cirurgia from "../../../components/Cirurgia";
import ModalComponent from "../../../components/Modal";
import CardCirurgia from "./components/CardCirurgia";

const ContCirurgia = ({interacao, cirurgia, paciente, preloadCirurgia, usuario, carregar, contexto}) => {

    const [ itemCirurgia, setItemCirurgia ] = useState(null);
    const [ visibleModal, setVisibleModal ] = useState(false);

    const openModal = (item) => {
        setVisibleModal(true);
        setItemCirurgia(item);
    }

    return(
      <>
        <div className="p-2">
    
            {preloadCirurgia ? (<><PreLoaderWidget /></>) :
                cirurgia != null ?
                    cirurgia.map((item, index) => {
                    return (
                        <div className="row">
                            <div className="col-sm-12">
                                <CardCirurgia
                                    idCirurgia={cirurgia.id}
                                    card={"cirurgia"}
                                    paciente={paciente}
                                    Hora={item.cirurgia.Hora ? item.cirurgia.Hora : null}
                                    interacao={interacao}
                                    Concluida={item.cirurgia.realizada === true ? "Realizada" : null}
                                    Cancelada={item.cirurgia.cancelada === true ? "Cancelada": null}
                                    DataCriacao={item.cirurgia.DataCriacao}
                                    profissional={item.profissional.nome}
                                    DataCirurgia={item.cirurgia.DataCirurgia}
                                    HoraCirurgia={item.cirurgia.HoraCirurgia}
                                    Hospital={item.cirurgia.Hospital}
                                    SolicitarMaterial={item.cirurgia.SolicitarMaterial}
                                    OpenModal={() => openModal(item)}
                                    Procedimento={item.cirurgia.procedimento}
                                    cirurgia={item}
                                    carregar={carregar}
                                    contexto={contexto}
                                />
                            </div>
                        </div>
                    );
                    }) :
                    null
            }
                        
        </div>
        <ModalComponent
            style={{ zIndex: 99999 }}

            openModal={visibleModal}
            closeModal={() => {
                //carregar();
                setVisibleModal(false);
            }}
        >
        <Cirurgia
            item={itemCirurgia}
            usuario={usuario}
            idPaciente={paciente.id}
          //  dataAtendimento={null}
        />
        </ModalComponent>
      </>
    )
}

export default ContCirurgia;